import type { IconName } from '@/ui'

/** Final pt-BR copy (handoff §6). */
export const S = {
  identification: 'Identificação',
  name: 'Nome',
  address: 'Endereço',
  phone: 'Telefone',
  editable: 'Dados editáveis',
  edit: 'Editar',
  cancel: 'Cancelar',
  save: 'Salvar alterações',
  saved: 'Dados do condomínio atualizados',
  saveError: 'Não foi possível salvar. Tente de novo.',
  email: 'E-mail de contato',
  website: 'Site',
  history: 'História',
  historyHint: 'Aparece no fim da tela Sobre.',

  rules: 'Regras do condomínio',
  addRule: 'Adicionar regra',
  ruleAddTitle: 'Adicionar uma regra',
  ruleEditTitle: 'Editar regra',
  ruleSave: 'Salvar regra',
  ruleTitle: 'Título',
  ruleTitlePlaceholder: 'Bicicletas',
  ruleDescription: 'Descrição',
  ruleDescriptionPlaceholder:
    'Estacione as bicicletas no bicicletário perto da rampa da garagem, nunca nos corredores.',
  ruleDescriptionHint:
    'Os moradores leem isto na aba Condomínio, então escreva uma frase completa.',
  icon: 'Ícone',
  editRule: (title: string) => `Editar regra: ${title}`,
  deleteRule: (title: string) => `Excluir regra: ${title}`,

  contacts: 'Contatos',
  addContact: 'Adicionar contato',
  contactAddTitle: 'Adicionar um contato',
  contactEditTitle: 'Editar contato',
  contactSave: 'Salvar contato',
  contactName: 'Nome',
  contactNamePlaceholder: 'Portaria',
  contactRole: 'Função',
  contactRolePlaceholder: 'Portaria 24h',
  contactPhone: 'Telefone',
  contactPhonePlaceholder: '+55 11 3333-4444',
  contactNote:
    'Os contatos são visíveis a todos os moradores do condomínio — use um número de trabalho, não pessoal.',
  editContact: (name: string) => `Editar contato: ${name}`,
  deleteContact: (name: string) => `Excluir contato: ${name}`,
  genericError: 'Não foi possível salvar. Tente de novo.',
} as const

/** DS icon names offered for rules (the reference's placeholders were swapped for these). */
export const RULE_ICONS: { name: IconName; label: string }[] = [
  { name: 'volume_off', label: 'Silêncio' },
  { name: 'pets', label: 'Animais' },
  { name: 'local_shipping', label: 'Mudanças' },
  { name: 'door_front', label: 'Portas' },
  { name: 'notifications', label: 'Avisos' },
  { name: 'flag', label: 'Bandeira' },
  { name: 'key', label: 'Chave' },
  { name: 'shield', label: 'Segurança' },
  { name: 'schedule', label: 'Horário' },
]
